import React, { memo } from 'react';
export const SolutionSection = memo(function SolutionSection() {
  return <section className="py-16 px-4 bg-gray-950 border-y border-gray-800" data-id="element-187">
      <div className="max-w-4xl mx-auto text-center" data-id="element-188">
        {/* Badge */}
        <div className="inline-block px-5 py-1.5 rounded-full font-bold text-sm mb-6 text-blue-400 bg-blue-500/10 border border-blue-500/30 uppercase tracking-widest" data-id="element-189">
          ⚡ LA SOLUCIÓN
        </div>

        {/* Headline */}
        <h2 className="text-[24px] md:text-4xl font-black mb-4 text-white leading-tight" data-id="element-190">
          El único sistema que te lleva de cero a profesional de la electricidad en 30 días
        </h2>

        {/* Product Name */}
        <div className="my-8" data-id="element-191">
          <h3 className="text-[32px] md:text-6xl font-black text-blue-500 tracking-tight mb-2" data-id="element-192">
            MEGAPACK ELÉCTRICO PRO
          </h3>
          <p className="text-gray-400 text-[14px] md:text-lg font-bold uppercase tracking-[0.2em]" data-id="element-193">
            6 Tomos Progresivos · Normativa AEA Real · Resultados Inmediatos
          </p>
        </div>

        {/* Description */}
        <p className="text-gray-400 text-[14px] md:text-lg leading-relaxed mb-10 max-w-2xl mx-auto" data-id="element-194">
          No es un curso ni un video de YouTube. Es un <strong className="text-white" data-id="element-195">método estructurado</strong> que escala desde arreglar tu hogar hasta certificar instalaciones industriales, sin conocimiento previo y aplicable desde el primer día.
        </p>

        {/* Value Indicators */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-196">
          {[{
          icon: '📚',
          text: '6 Tomos PDF Progresivos'
        }, {
          icon: '🎯',
          text: 'Aplicable desde el Día 1'
        }, {
          icon: '🇦🇷',
          text: 'Normativa AEA Argentina'
        }, {
          icon: '⏱️',
          text: 'Resultados en 30 Días'
        }].map((indicator, i) => <div key={i} className="p-4 rounded-xl bg-gray-900 border border-gray-800 flex flex-col items-center justify-center gap-3 hover:border-blue-500/50 transition-colors" data-id="element-197">
              <div className="text-3xl" data-id="element-198">{indicator.icon}</div>
              <p className="text-white font-bold text-[13px] md:text-sm text-center leading-tight" data-id="element-199">
                {indicator.text}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
});